// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"31aae43d","239":"00571ff2","453":"ef557e67","732":"e05c44ff"}[chunkId] + ".chunk.js";
};